import React from 'react'

import blog1 from './../../assets/blogs/blog1.png'
import blog2 from './../../assets/blogs/blog2.png'
import blog3 from './../../assets/blogs/blog3.png'
import blog4 from './../../assets/blogs/blog4.png'
import blog5 from './../../assets/blogs/blog5.png'

import { Link } from 'react-router-dom'
import { motion } from 'framer-motion';

import mainImg from './../../assets/blogs/mainImg.png'

import calenderIcon from './../../assets/blogs/calender.svg'

const Blogs = () => {
    const blogs = [
        {
            id: 1,
            image: blog1,
            url: "/blogs/1",
            date_day: "08",
            date_month: "March",
            title: "Inland freight a worthy solution for your business",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 2,
            image: blog2,
            url: "/blogs/2",
            date_day: "12",
            date_month: "March",
            title: "How technology can help redraw the supply chain map",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 3,
            image: blog3,
            url: "/blogs/3",
            date_day: "25",
            date_month: "March",
            title: "Five things you should have ready for your broker",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
        {
            id: 4,
            image: blog4,
            url: "/blogs/4",
            date_day: "28",
            date_month: "March",
            title: "Four simple tips for becoming a healthier truck driver",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],

        },
        {
            id: 5,
            image: blog5,
            url: "/blogs/5",
            date_day: "30",
            date_month: "March",
            title: "What Is The Role Of A Logistics Operations Manager",
            paragraph: "We are dedicated in creating added value for our customers by implementing modern technology in our work. ",
            props: [
                "Urgent transport solutions",
                "Reliable & experienced staffs",
                "Urgent transport solutions",
                "Reliable & experienced staffs"
            ],
        },
    ]
    return (
        <div>
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${mainImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-dark-navy to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-gold text-sm ">Blog</span>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">Our Latest News</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_2 blog py-20">
                <div className="content w-4/5 sm:w-2/3 lg:w-2/3 m-auto flex flex-col items-center">
                    <div className="text-center w-full border-b-2 pb-10 mt-5">
                        <span className="bg-gray-light p-1 px-2 border-l-4 border-l-gold text-sm ">Our Blog</span>
                        <h2 className="text-3xl text-dark font-semibold my-2">Our Latest News</h2>
                    </div>
                    {blogs.map(blog => (
                        <div key={blog.id} className="grid grid-cols-1 lg:grid-cols-2 gap-2 py-5 border-b-2">
                            <div className="col-span-1">
                                <div className="image_box relative flex justify-center items-center group">
                                    <img src={blog.image} alt="" className="h-full w-full" />
                                    <Link to={blog.url} className="layer group-hover:opacity-70 group-hover:w-full group-hover:h-full duration-300  opacity-0 h-0 w-0 bg-main-light absolute text-white text-sm font-Krub font-semibold flex justify-center items-center">
                                        Read More
                                    </Link>
                                </div>
                            </div>
                            <div className="col-span-1  md:px-4 flex gap-5 flex-col xxs:flex-row">
                                <div className="calender xxs:border-r-2 xxs:pe-5 xxs:text-center flex gap-5 xxs:block">
                                    <img src={calenderIcon} alt="" className='' />
                                    <div className="">
                                        <p className='text-4xl font-semibold'>{blog.date_day}</p>
                                        <p className='text-sm text-gray font-medium font-Krub'>{blog.date_month}</p>
                                    </div>
                                </div>
                                <div className="">
                                    <h3 className="text-2xl hover:text-gold text-dark">{blog.title}</h3>
                                    <p className="text-Krub my-3 text-sm text-gray">{blog.paragraph}</p>
                                    <ul className="list-disc list-inside grid gap-1">
                                        {blog.props.map((prop, i) => <li key={i} className="text-sm text-dark font-Krub font-medium ">{prop}</li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Blogs